// extracted by mini-css-extract-plugin
export default {"page404":"notFound_page404__FTDB0"};